import { render, staticRenderFns } from "./SendToSolvoButton.vue?vue&type=template&id=a1da7eb8&"
import script from "./SendToSolvoButton.vue?vue&type=script&lang=js&"
export * from "./SendToSolvoButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports